import { Box, Text } from '@chakra-ui/react'
import React from 'react'
import type { NodeProps } from '../../node-catalog'
import { WorkflowNode } from '../node'

export const SessionCompletedTrigger = ({
  config,
  hasChildren,
  isParent,
  isSelected,
  onClick
}: NodeProps) => {
  const {
    filters
  }: {
    filters: Array<{
      filterType: string
      filterValues: Array<string>
      filterOperator: string
    }>
  } = config

  const body = (
    <Box>
      <Text mb="small">Session is completed</Text>
      {filters.map(
        (
          f: {
            filterType: string
            filterValues: Array<string>
            filterOperator: string
          },
          idx: number
        ) => {
          if (f.filterType === 'sessionsCompleted') {
            return <Text mt="small">First session is completed </Text>
          }
          return null
        }
      )}
    </Box>
  )

  return (
    <WorkflowNode
      heading="Session Completed Trigger"
      body={body}
      isParent={isParent}
      hasChildren={hasChildren}
      isSelected={isSelected}
      onClick={onClick}
    />
  )
}
